import {construct, forEach, length, objOf, pipe} from 'ramda';

const createVue = pipe(objOf('el'), construct(Vue));

/**
 *
 * @param {string} selector
 */
export default async function initCountdown(selector) {
    const timers = document.querySelectorAll(selector);
    const noTimers = length(timers) === 0;

    if (noTimers) return;

    const {Countdown} = await import('../components/Countdown');

    Vue.component('countdown', Countdown);
    forEach(createVue, timers);
}
